import { motion } from "framer-motion";

const CHAPTERS = [
  {
    number: "01",
    title: "The Foundation — 1968",
    content:
      "Carved out of Mortlake volcanic soil and Darlington clay by passionate local racers, the Mortlake Car Club built a sanctuary for grassroots Australian motorsport. Key figures like Bob Ross, who contributed until 2012, helped shape this venue into what it is today.",
  },
  {
    number: "02",
    title: "The 310M Clay Oval",
    content:
      "A high-banked 310-metre clay arena engineered for tight wheel-to-wheel battles, heavy dust roost and high-side thrills — plus a brand-new purpose-built 110-metre JQMV and kart track right on the infield for our youngest racers.",
  },
  {
    number: "03",
    title: "The Volunteer Spirit",
    content:
      "Maintained by generations of local mechanics, families and racing purists who keep the speedway lights burning through thick and thin. Every membership dollar goes straight back into venue improvements and running costs.",
  },
];

export default function Manifesto() {
  return (
    <section id="legacy" className="max-w-[1400px] mx-auto px-4 sm:px-8 py-20 lg:py-32">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="font-mono text-xs uppercase tracking-[0.35em] text-clay-orange mb-4"
      >
        Our Passion, Your Speedway
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.1 }}
        className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-5xl lg:text-6xl leading-none mb-16"
      >
        A Legacy Built on <span className="text-stroke">Passion</span> & Community
      </motion.h2>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-px bg-clay-border/60 border border-clay-border/60">
        {CHAPTERS.map((c, i) => (
          <motion.article
            key={c.number}
            data-testid={`manifesto-chapter-${i + 1}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="group bg-clay-bg p-8 sm:p-10 hover:bg-clay-surface transition-colors duration-500 relative overflow-hidden"
          >
            <span className="font-display font-black text-7xl sm:text-8xl text-clay-card group-hover:text-clay-orange/20 transition-colors duration-500 absolute -top-3 right-4 select-none">
              {c.number}
            </span>
            <p className="font-mono text-xs tracking-[0.3em] text-clay-gold mb-6">CHAPTER {c.number}</p>
            <h3 className="font-display font-bold uppercase text-2xl sm:text-3xl tracking-tight mb-5 relative z-10">
              {c.title}
            </h3>
            <p className="text-clay-muted leading-relaxed relative z-10">{c.content}</p>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
